<template>
  <div style="background: white">
    <K2Row justify_content="center" class="position-relative p-4">
      <K2Row :style="{ background: uiVariable.color.button1 }" style="cursor: pointer" class="backButton pe-3 rounded po" align="center" @onclick="handleClick">
        <K2Icon color="white" name="chevron_left" font-size="29px" />
        <K2Text color="white">{{ lang('Back') }}</K2Text>
      </K2Row>
      <K2Heading type="h5" class-name="mb-0" color="black">{{ lang('Create New Post') }}</K2Heading>
    </K2Row>
    <div class="box base pt-3 p-md-3">
      <K2Row class="mobile-block">
        <!--left column-->
        <div class="col-12 col-md-9">
          <div class="box white p-3 mb-3">
            <K2Row class="mb-3 border-bottom pb-3">
              <K2Button size="small" theme="2" class="me-2" @onclick="handleLoad('Template')">
                {{ lang('Load From Template') }}
              </K2Button>
              <K2Button size="small" theme="2" @onclick="handleLoad('Draft')">
                {{ lang('Load From Draft') }}
              </K2Button>
            </K2Row>
            <div class="box white mb-3">
              <K2Row align="center">
                <K2Text bold="true" class="text-left d-block me-3 mb-2">{{ lang('Select Post Type') }} </K2Text>
                <el-radio v-model="postType" label="Update">
                  {{ lang('Feeds') }}
                </el-radio>
                <el-radio v-if="userRole === 'Principal'" v-model="postType" label="Broadcast">
                  {{ lang('Broadcasts') }}
                </el-radio>
                <el-radio v-model="postType" label="Moment">
                  {{ lang('Moments') }}
                </el-radio>
              </K2Row>
            </div>
            <K2Text bold="true" class-name="mb-3 text-left d-block" :style="{ fontSize: uiVariable.fontSize.lg }" required="true">{{ lang('Title') }} </K2Text>
            <div class="mb-3">
              <el-input v-model="title"></el-input>
            </div>
            <K2Text bold="true" class-name="mb-3 text-left d-block" :style="{ fontSize: uiVariable.fontSize.lg }" required="true"
              >{{ lang('Content') }}
            </K2Text>
            <div class="mb-3">
              <K2Editor v-model="content" @input="onEditorChange" :passContent="content" :passIsMoment="postType === 'Moment'" />
            </div>
          </div>
          <activityMedia @getselectedfiles="gSelectedUploadFiles($event)" :passselectedfile="tselectedfiles" :passPostType="postType" />
          <activityStudents
            @tags="gTags($event)"
            @sAllLevels="pAllLevelsList($event)"
            @clearStudents="clearStudents"
            @handleResetGoals="handleResetGoals()"
            @isCheckAll="gAllLevels($event)"
            :postType="postType"
            @isAllClasses="gIsAllClasses($event)"
            @selectedclasses="gSelectedClasses($event)"
            @selectedLevels="gSelectedLevels($event)"
            @handleStudentPlannerOnSelect="handleStudentPlannerOnSelect"
            :passmselectedstudents="tselectedstudents"
            :passmseelctedclasses="tselectedclasses"
            :passSelectedLevel="tselectedLevels"
            :passisalllevel="misselectedalllevels"
          />
          <ActivityGoal
            @developmentgoals="gDevelopmentGoals($event)"
            :mselectedstudents="this.mselectedstudents"
            :misselectedclasses="this.misselectedclasses"
            :goalsList="this.goalsList"
            :tselectedGoals="tselectedGoals"
            @loadDomainList="loadDomainList"
            :porDevelopmentDomainList="this.porDevelopmentDomainList"
            :obj_Post="obj_Post"
          />
        </div>
        <!--right column-->
        <div class="mt-3 mt-md-0 col-12 col-md-3">
          <ActivityPublish
            :passtaparent="content"
            :posttitle="title"
            :passselectedfile="mselectedfiles"
            @handleLoad="handleLoad"
            :postType="postType"
            :isUpdate="isUpdate"
            :parentPost="updatePost"
            :userRole="userRole"
            :passmselectedstudents="mselectedstudents"
            :passkeytags="mselectedkeytags"
            :passdevelopmentgoals="this.porDevelopmentObject"
            :passSelectedLevel="mselectedlevels"
            :passmisselectedalllevels="misselectedalllevels"
            :passmisallclasses="misAllClasses"
            :passmseelctedclasses="misselectedclasses"
            :passmselectedlevels="misselectedLevels"
          />
          <ActivityTag @keytags="gKeytags($event)" :tpostkeytag="tpostkeytag" @handleRemoveGoals="handleRemoveGoals" />
        </div>
      </K2Row>
      <K2Modal
        :fullscreen="true"
        :dialog="modal === 'Template' || modal === 'Draft'"
        @handleClose="handleClose"
        @onConfirm="handleClose"
        :hideFooter="true"
        :hideHeader="true"
      >
        <K2Row justify_content="center" class="position-relative" align="center">
          <K2Icon color="black" name="chevron_left" @onclick="handleClose" link="true" class="backButton" style="top: 0" />
          <K2Heading type="h5" class-name="mb-0" color="black" v-if="isTemplate">{{ lang('Select Template') }} </K2Heading>
          <K2Heading type="h5" class-name="mb-0" color="black" v-else>{{ lang('Select Draft') }}</K2Heading>
        </K2Row>
        <ActivityTemplate @handleClose="handleClose" :modal="modal" @useTemplate="useTemplate" :templateList="templateList" @getTemplate="getTemplate" />
      </K2Modal>
    </div>
  </div>
</template>
<script>
import K2Heading from '../../uiComponents/k2Heading/k2Heading'
import K2Icon from '../../uiComponents/k2Icon/k2MAIcon'
import K2Row from '../../uiComponents/k2Row/k2Row'
import K2Text from '../../uiComponents/k2Text/k2Text'
import uiVariable from '../../config/uiVariable'
import K2Input from '../../uiComponents/k2Input/k2Input'
import K2Button from '../../uiComponents/k2Button/k2Button'
import './activity.scss'
import ActivityMedia from './component/activityMedia'
import ActivityStudents from './component/activityStudents'
import ActivityGoal from './component/activityGoal'
import ActivityPublish from './component/activityPublish'
import ActivityTag from './component/activityTag'
import DataSource from '../../data/datasource'
import K2Modal from '../../uiComponents/k2Modal/k2Modal'
import ActivityTemplate from './component/activityTemplate'
import Cookies from 'js-cookie'
import { lang } from '../../locale'
import K2Editor from '../../uiComponents/k2Editor/k2Editor'

export default {
  name: 'NewActivityJapanPage',
  components: {
    K2Editor,
    ActivityTemplate,
    K2Modal,
    ActivityTag,
    ActivityPublish,
    ActivityGoal,
    ActivityStudents,
    ActivityMedia,
    K2Button,
    K2Input,
    K2Text,
    K2Row,
    K2Icon,
    K2Heading,
  },
  props: ['handleBack', 'post'],
  data() {
    return (window.debug = {
      uiVariable: uiVariable,
      search: '',
      arrobj_Levels: [],
      studentList: null,
      title: '',
      content: '',
      postType: null,
      mselectedfiles: [],
      mselectedstudents: [],
      mselectedlevels: [],
      tselectedLevels: [],
      mselectedkeytags: [],
      misselectedalllevels: '',
      misAllClasses: '',
      misselectedclasses: [],
      tselectedclasses: [],
      tselectedstudents: [],
      tselectedGoals: [],
      tpostkeytag: [],
      tselectedfiles: [],
      misselectedLevels: [],
      missingleselectclass: [],
      ddlLearningMomentsList: [],
      obj_Post: {
        PostID: '',
        PostPorDtlTitle: '',
        PostPorDtlObservation: '',
        PostPorDtlAnalysisReflection: '',
        PostPorDtlDevelopmentGoals: [],
      },
      goalsList: [],
      porDevelopmentDomainList: [],
      porDevelopmentObject: [],
      modal: null,
      isTemplate: false,
      templateList: null,
      isUpdate: false,
      updatePost: null,
      ddlClassList: [],
      ddlLevelList: [],
      currentSchool: null,
      userRole: '',
      isSchool: false,
      useDraft: null,
    })
  },
  mounted() {
    this.init()
    this.currentSchool = Cookies.get('userSchoolNameSession')
    const self = this
    this.userRole = Cookies.get('userTypeSession')
  },
  methods: {
    lang,
    async init() {
      await this.sortByLevelClass()
      this.postType = 'Update'

      if (this.userRole === 'Principal') {
        // this.postType = "Update"; // since principal only has broadcast option, let's select by default.
        // this.misselectedalllevels = true;
        // this.misselectedLevels = this.ddlLevelList.map(x => ({ ...x, checked: true, isLevel: true }));
      }
      if (this.$route.params.post) {
        this.handleUpdate()
      }
    },
    isNull(obj) {
      return obj === null || obj === undefined || obj === 'undefined' || obj.length === 0 || obj === ''
    },
    onEditorChange(value) {
      this.content = value
    },
    handleUpdate() {
      let paramsPost = this.$route.params.post
      if (paramsPost) {
        this.isUpdate = true
        this.updatePost = paramsPost
        this.content = paramsPost.PostContent || paramsPost.PostUpdDtlDescription
        this.title = paramsPost.PostUpdDtlTitle
        this.tselectedfiles = paramsPost.postFiles
        this.postType = paramsPost.PostType === 'Feed' ? 'Update' : paramsPost.PostType
        if (paramsPost.PostKeyTags) {
          paramsPost.PostKeyTags.forEach(d => {
            this.tpostkeytag.push(d.PostKeyTagValue)
          })
        }
        if (paramsPost.PostLearningMoments) {
          let tempGoalsList = []
          paramsPost.PostLearningMoments.forEach(d => {
            tempGoalsList.push({
              Domain: d.PostUpLMDomain,
              Goals: d.PostUpLMGoals,
              Indicator: d.PostUpLMIndicator,
              KeyId: d.PostUpLMID,
              remarks: d.PostUpLMRemarks,
              termlyReport: d.PostUpLMTermReport,
            })
          })
          this.tselectedGoals = tempGoalsList
          this.porDevelopmentObject = tempGoalsList
        }
        // if (paramsPost.school) {
        //   this.postType = "Broadcasts";
        // }
        if (paramsPost.levelList && paramsPost.levelList.length > 0) {
          this.tselectedLevels = paramsPost.levelList
        }
        if (paramsPost.classList && paramsPost.classList.length > 0) {
          this.tselectedclasses = paramsPost.classList
        }
        if (paramsPost.studentList && paramsPost.studentList.length > 0) {
          if (paramsPost.studentList) {
            this.tselectedstudents = paramsPost.studentList
          }
        }
        if (paramsPost.school) {
          this.misselectedalllevels = true
          this.tselectedLevels = this.ddlLevelList
        }
      }
    },
    gSelectedUploadFiles(gselectedfiles) {
      this.mselectedfiles = gselectedfiles
    },
    gTags(gselectedstudents) {
      this.mselectedstudents = gselectedstudents
    },
    pAllLevelsList(gselectedlevels) {
      this.mselectedlevels = gselectedlevels
    },
    gAllLevels(sisAlllevels) {
      this.misselectedalllevels = sisAlllevels
    },
    gIsAllClasses(sisAllClasses) {
      this.misAllClasses = sisAllClasses
    },
    gSelectedClasses(sSelectedClasses) {
      this.misselectedclasses = []
      this.misselectedclasses.push(...sSelectedClasses)
    },
    gSelectedLevels(sSelectedLevels) {
      this.misselectedLevels = sSelectedLevels
    },
    gSelectSingleClass(ssingleselectclass) {
      this.missingleselectclass = ssingleselectclass
    },
    gKeytags(gkeytags) {
      this.mselectedkeytags = gkeytags
      // alert(this.mselectedkeytags);
    },
    handleRemoveGoals(goalList) {
      this.goalsList = goalList
    },
    handleResetGoals() {
      this.tselectedGoals = []
      this.goalsList = []
      this.loadDomainList()
    },
    gDevelopmentGoals(gactivitygoals) {
      this.mselecteddevelopmentgoals = gactivitygoals
      //  alert(this.mselecteddevelopmentgoals);
    },
    showLoading() {
      this.$vs.loading()
    },
    hideLoading() {
      this.$vs.loading.close()
    },
    handleClick() {
      this.$router.push('/Activity')
    },
    handleInputChange(value, name) {
      this[name] = value
    },
    handleStudentPlannerOnSelect() {
      if (this.mselectedstudents && this.mselectedstudents.length > 0) {
        this.GetStudentPlanner()
      } else if (this.misselectedclasses) {
        this.GetStudentPlannerByClass(this.misselectedclasses)
      }
    },
    async GetStudentPlanner() {
      try {
        let StudentIDList = []
        let classID = []
        if (this.mselectedstudents[0].classID) {
          let tempClassList = {
            classID: this.mselectedstudents[0].classID,
          }
          classID.push(tempClassList)
        } else {
          this.ddlClassList.forEach(d => {
            if (d.Str_SortBy.trim() === this.mselectedstudents[0].CLS_ClassName.trim()) {
              let tempClassList = {
                classID: d.Str_ID,
              }
              classID.push(tempClassList)
            }
          })
        }

        this.mselectedstudents.forEach(item => {
          item.itemList.forEach(d => {
            let tempStudentIDList = {
              StudentID: d.Student_ID || d.PostTagUserID,
            }
            StudentIDList.push(tempStudentIDList)
          })
        })

        if (StudentIDList.length > 0) {
          const response = await DataSource.shared.getPlannerAssignedStudentsGroupByClassIDK2(classID, StudentIDList)

          if (response) {
            if (response.code === '88') {
              window.location.replace('/')
            } else if (response.code === '99') {
              console.log('getPlannerAssignedStudentsGroupByClassID Error')
            } else if (response.code === '2') {
              //comment due to effect loading speed
              // console.log('getPlannerAssignedStudentsGroupByClassID no record');
            } else {
              this.obj_Post.PostPorDtlDevelopmentGoals = []

              // const newArray = []
              // response.Table.forEach(d => {
              //   const exist = newArray.find(v => v.PlnStaDomain === d.PlnStaDomain)
              //   if (exist) {
              //     exist.PlnStaIndicator.push(d.PlnStaIndicator)
              //   } else {
              //     const newObj = {
              //       PlnStaDomain: d.PlnStaDomain,
              //       PlnStaIndicator: []
              //     }
              //     newArray.push(newObj)
              //   }
              // })
              this.goalsList = response.Table

              this.goalsList.forEach((goal, gIndex) => {
                goal.KeyId = gIndex + 1
              })
              this.loadDomainList()
            }
          }
        }
      } catch (e) {
        console.log('getPlannerAssignedStudentsGroupByClassID error', e)
      }
    },
    async GetStudentPlannerByClass(Classes) {
      try {
        let ClassIDList = []

        Classes.forEach(item => {
          let tempClassList = {
            classID: item.Str_ID,
          }
          ClassIDList.push(tempClassList)
        })

        let StudentIDList = []
        this.mselectedstudents.forEach(item => {
          item.itemList.forEach(d => {
            let tempStudentIDList = {
              StudentID: d.Student_ID,
            }
            StudentIDList.push(tempStudentIDList)
          })
        })

        // if (Classes.length > 0) {
        //     for (let item of Classes) {
        //         const response = await DataSource.shared.getPlannerAssignedStudentsGroupByClassIDK2(item.Str_ID);
        const response = await DataSource.shared.getPlannerAssignedStudentsGroupByClassIDK2(ClassIDList, StudentIDList)

        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            console.log('getPlannerAssignedStudentsGroupByClassID Error')
          } else if (response.code === '2') {
            console.log('getPlannerAssignedStudentsGroupByClassID no record')
          } else {
            this.obj_Post.PostPorDtlDevelopmentGoals = []

            this.goalsList = response.Table
            this.goalsList.forEach((goal, gIndex) => {
              goal.KeyId = gIndex + 1
            })
            this.loadDomainList()
          }
        }
        //     }
        // }
      } catch (e) {
        console.log('getPlannerAssignedStudentsGroupByClassID error', e)
      }
    },
    loadDomainList(porDevelopmentObject) {
      if (porDevelopmentObject) {
        this.porDevelopmentObject = porDevelopmentObject
      }
      let sortedList = this.groupBy(this.goalsList, 'PlnMasDomain')
      this.porDevelopmentDomainList = []
      sortedList.forEach(item => {
        this.porDevelopmentDomainList.push(item)
      })
    },
    async sortByLevelClass() {
      try {
        const result = await DataSource.shared.getAllActiveStudentsBySchoolWithMode('ProfileImagePhysicalPath')
        if (result) {
          if (result.code === '88') {
            window.location.replace('/')
            return
          }
          if (this.isNull(result.Table)) {
            return
          }
          this.groupStudentList(result.Table)
        }
      } catch (e) {
        console.log('sortByLevelClass err', e)
      }
    },
    groupStudentList(result) {
      let classList = []
      let levelList = []
      let sortedList = this.groupBy(result, 'SMT_Code', 'SMT_Code')
      for (let i = 0; i < sortedList.length; i++) {
        let tempLevel = this.groupBy(sortedList[i].ArrObj_Items, 'CRS_Course_Name', 'CRS_Course_Name', 'PK_Course_ID')
        for (let j = 0; j < tempLevel.length; j++) {
          let tempClass = this.groupBy(tempLevel[j].ArrObj_Items, 'CLS_ClassName', 'CLS_ClassName', 'PK_Class_ID')
          tempLevel[j].ArrObj_Items = tempClass
        }
        sortedList[i].ArrObj_Items = tempLevel
      }
      sortedList.forEach(d => {
        d.ArrObj_Items.forEach(m => {
          levelList.push(m)
          m.ArrObj_Items.forEach(e => {
            classList.push(e)
          })
        })
      })
      this.ddlClassList = classList
      this.ddlLevelList = levelList
    },
    groupBy(data, key, display, id) {
      let ArrObj_Sorted = []
      let arrstr_display = !this.isNull(display) ? display.split(',') : [key]
      for (let item of data) {
        let index = ArrObj_Sorted.findIndex(x => x.Str_SortBy === item[key])
        if (index === -1) {
          let str_Display = ''
          for (let tempdisp of arrstr_display) str_Display += item[tempdisp] + ' '
          ArrObj_Sorted.push({
            Str_SortBy: item[key],
            Str_Display: str_Display,
            Str_ID: item[id],
            ArrObj_Items: [item],
          })
        } else ArrObj_Sorted[index].ArrObj_Items.push(item)
      }
      return ArrObj_Sorted
    },
    handleClose() {
      this.modal = null
    },
    handleLoad(type) {
      this.getTemplate(type)
      this.isTemplate = type === 'Template'
      this.modal = type
    },
    useTemplate(feed) {
      if (this.modal === 'Draft') {
        this.updatePost = feed
      }
      this.modal = null
      this.misselectedclasses = []
      this.getTemplateFile(feed.POSTID)
      this.getTemplateKeyTag(feed.POSTID)
      this.getDevelopmentGoals(feed.POSTID)
      this.fetchPostSelectedTag(feed)
      if (feed) {
        if (feed.PostUpLMDomain) {
          let tempGoals = {
            Domain: feed.PostUpLMDomain,
            Indicator: feed.PostUpLMGoals,
          }
          this.tselectedGoals.push(tempGoals)
        }
        this.content = feed.POSTCONTENT || feed.PostUpdDtlDescription
        this.title = feed.PostUpdDtlTitle
        this.postType = feed.POSTTYPE === 'Feed' ? 'Update' : feed.POSTTYPE
      }
    },
    async fetchPostSelectedTag(feed) {
      this.tselectedLevels = []
      this.tselectedclasses = []
      this.tselectedstudents = []
      const response = await DataSource.shared.getPostTagListByPostID(feed.POSTID)
      if (response.Table) {
        response.Table.forEach(d => {
          if (d.IsAllLevel) {
            this.isSchool = true
            this.misselectedalllevels = true
          } else {
            this.isSchool = false
            if (d.PostTagClassID) {
              this.handleClassList(response.Table)
            } else if (d.PostTagLevelID) {
              this.handleLevelList(response.Table)
            } else {
              this.handleStudent(response.Table)
            }
          }
        })
      }
    },
    async handleStudent(students) {
      if (students) {
        this.tselectedstudents = students
      }
    },
    handleClassList(classes) {
      if (classes) {
        this.ddlClassList.forEach(m => {
          classes.forEach(d => {
            if (d.PostTagClassID && m.Str_ID) {
              if (d.PostTagClassID === m.Str_ID) {
                if (this.classList && this.classList.length > 0) {
                  const exist = this.classList.find(x => x.Str_ID === m.Str_ID)
                  if (!exist) {
                    this.tselectedclasses.push(m)
                  }
                } else {
                  this.tselectedclasses.push(m)
                }
              }
            }
          })
        })
      }
    },
    handleLevelList(level) {
      if (level) {
        this.ddlLevelList.forEach(m => {
          level.forEach(d => {
            if (d.PostTagLevelID && m.Str_ID) {
              if (d.PostTagLevelID === m.Str_ID) {
                const exist = this.tselectedLevels.find(x => x.Str_ID === m.Str_ID)
                if (!exist) {
                  this.tselectedLevels.push(m)
                }
              }
            }
          })
        })
      }
    },
    async getTemplateFile(POSTID) {
      let response = await DataSource.shared.getPostFileReturnFilePath(POSTID)
      if (response) {
        this.tselectedfiles = response.Table
      }
    },
    async getTemplateKeyTag(POSTID) {
      let response = await DataSource.shared.getPostKeyTag(POSTID)
      if (response) {
        if (response.Table) {
          response.Table.forEach(d => {
            this.tpostkeytag.push(d.PostKeyTagValue)
          })
        }
      }
    },
    async getDevelopmentGoals(POSTID) {
      let response = await DataSource.shared.getPostDevelopmentGoals(POSTID)
      if (response) {
        if (response.Table) {
          let tempGoalsList = []
          response.Table.forEach(d => {
            tempGoalsList.push({
              Domain: d.PostUpLMDomain,
              Goals: d.PostUpLMGoals,
              Indicator: d.PostUpLMIndicator,
              KeyId: d.PostUpLMID,
            })
          })
          this.tselectedGoals = tempGoalsList
          this.porDevelopmentObject = tempGoalsList
        }
      }
    },
    clearStudents() {
      this.tselectedstudents = []
      this.tselectedclasses = []
      this.tselectedLevels = []
      this.misAllClasses = null
      this.misselectedalllevels = null
      this.mselectedlevels = null
      this.handleResetGoals()
    },
    async getTemplate(type, length) {
      this.showLoading()

      this.templateList = null
      let numberOfPost
      if (length) {
        numberOfPost = length + 8
      } else {
        numberOfPost = 8
      }
      if (!type) {
        type = this.modal
      }
      const response = await DataSource.shared.getLoadTemplate('Self', type, numberOfPost)
      if (response) {
        if (response.code === '88') {
          window.location.replace('/')
        } else if (response.code === '99') {
          console.log('getPlannerAssignedStudentsGroupByClassID Error')
        } else if (response.code === '2') {
          this.templateList = []

          this.$forceUpdate()

          console.log('getPlannerAssignedStudentsGroupByClassID no record')
        } else {
          for (let d of response.Table) {
            const result = await DataSource.shared.getPostFileReturnFilePath(d.POSTID)
            d.postFile = result.Table
          }
          this.templateList = response.Table
          this.$forceUpdate()
        }
      }
      this.hideLoading()
    },
  },
}
</script>
